import { defineStore } from 'pinia';
import { ref } from '#imports';

export const useModalStore = defineStore('modal', () =>{
    const name = ref('');
    const modalTarget = ref('#ds-modal-target');
    const open = ref(false);
    const closeOnBackdropClick = ref(true);
    const callerPayload = ref(null);

    const setNameAndOpen = (modalName, payload) => {
        name.value = modalName;
        open.value = true;
        callerPayload.value = payload;
    };

    const unsetNameAndClose = () => {
        name.value = '';
        open.value = false;
        callerPayload.value = null;
    };

    return {
        name,
        modalTarget,
        open,
        closeOnBackdropClick,
        setNameAndOpen,
        unsetNameAndClose,
        callerPayload,
    };
});
